module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "frontmatter",
      "title": "Acknowledgments"
    }
  }, [_c('p', {
    staticClass: "fm_h1",
    attrs: {
      "id": "sec2"
    }
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_xv",
      "title": "xv"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780253063526_Contents#rsec2"
    }
  }, [_vm._v("ACKNOWLEDGMENTS")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent_para"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("THE TRANSLATORS WISH TO GRATEFULLY")]), _vm._v(" acknowledge the assistance of the following:")]), _vm._v(" "), _c('p', {
    staticClass: "noindent_parat"
  }, [_vm._v("Barbara Mhic Con Iomaire; M.; Máirín Nic Con Iomaire & Dónall Ó Braonáin; John Drever; Jennika Baines, Lesley Bolton and all at Indiana University Press; Pete Feely and team, Amnet Systems; Seosamh Ó Murchú, Eagarthóir Sinsearach, An Gúm, Foras na Gaeilge; Jonny Dillon, Cnuasach Bhéaloideas Éireann/National Folklore Collection, UCD; Aisling Keane, James Hardiman Library, NUI Galway; Nessa Cronin, Centre for Irish Studies, NUI Galway; Seathrún Ó Tuairisg, Acadamh na hOllscolaíochta Gaeilge, NUI Galway; Nuala Ford and muintir Mhic Giollarnáth, Galway; Seán Ó Mainnín Photography, An Cheathrú Rua."), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_xvi",
      "title": "xvi"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0d18ad47","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/9780253063526_Acknowledgments.vue
// module id = 81
// module chunks = 0